import React from 'react';
import _ from 'lodash';

import { useAppleCareAgreementsWidgetQuery } from 'generated/graphql';
import { DateTime } from 'luxon';



export interface IAppleCareAgreement {
  id: string;
  orderNumber: string;
  orderDate: DateTime;
  productName: string;
  sku: string;
  agreementNumber: string;
  activatedAt: DateTime | null;
}

export interface IData {
  agreements: IAppleCareAgreement[];
}

export function useQuery() {
  const tuple = useAppleCareAgreementsWidgetQuery({});

  return React.useMemo(
    () => {
      const data: IData = {
        agreements: _.map(tuple.data?.appleCareAgreements.nodes ?? [], (node): IAppleCareAgreement => ({
          id: node.id,
          orderNumber: node.lineItem.order.orderNumber,
          orderDate: DateTime.fromISO(node.lineItem.order.orderDate),
          productName: node.lineItem.product.name,
          sku: node.lineItem.product.sku,
          agreementNumber: node.agreementNumber,
          activatedAt: node.activatedAt ? DateTime.fromISO(node.activatedAt) : null
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
